import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import { IconButton } from '@mui/material';
import { useNavigate } from 'react-router';
import UnreadMessagesBadge from '../../../atoms/UnreadMessagesBadge';
import { styles } from './Header.styles';

const NotificationButton = () => {
  const navigate = useNavigate();

  return (
    <IconButton
      data-testid='neobet-notifications-button'
      sx={styles.utilityIconButton()}
      onClick={() => navigate('/my-account/messages/inbox')}
    >
      <UnreadMessagesBadge>
        <MailOutlineRoundedIcon fontSize='small' />
      </UnreadMessagesBadge>
    </IconButton>
  );
};

export default NotificationButton;
